import logo from './logo.svg';
import './App.css';
import { Link } from 'react-router-dom'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1>
          Welome to my reactjs App
        </h1>
      <Link to="/about"> More... </Link>
      </header>
    </div>
  );
}

export default App;
